import APIClient from "../../../common/APIClient";
import {
  toggleShowAlert,
  displayError,
  SUCCESS_ALERT,
  ERROR_ALERT,
  MAX_ITEMS_IN_PAGE,
} from "../commonActions";
import { formatDate } from "../../../common/Utilities";
import { fetchProjects, getProject } from "../projects/projectsActions";
import { Cache } from "aws-amplify";
import moment from "moment";
import qs from "qs";
import { fetchTasks } from "../projects/tasksActions";
import { fetchProjectTasks } from "../projects/projectTasksActions";

export const FETCH_TASKS = "FETCH_TASKS";
export const FETCH_DAILY_TASKS = "FETCH_DAILY_TASKS";
export const FETCH_DAILY_TASK = "FETCH_DAILY_TASK";
export const FETCH_PROJECT_TASK_OPTION = "FETCH_PROJECT_TASK_OPTION";
export const ASSIGN_PROJECT_TASK_OPTION = "ASSIGN_PROJECT_TASK_OPTION";
export const ADD_DAILY_TASK_ENTRY = "ADD_DAILY_TASK_ENTRY";
export const ADD_TASK_ENTRY_DATE = "ADD_TASK_ENTRY_DATE";
export const ADD_TASK_ROW_NUM = "ADD_TASK_ROW_NUM";
export const SET_TASK_ROW_NUM = "SET_TASK_ROW_NUM";
export const DELETE_TASK_ENTRY = "DELETE_TASK_ENTRY";
export const UPDATE_TASK_ENTRIES = "UPDATE_TASK_ENTRIES";
export const UPDATE_TASK_ENTRY = "UPDATE_TASK_ENTRY";
export const SET_TASK_DATE = "SET_TASK_DATE";
export const FETCH_DAILY_TASK_ENTRY = "FETCH_DAILY_TASK_ENTRY";
export const FETCH_TEAM_DAILY_TASK_ENTRY = "FETCH_TEAM_DAILY_TASK_ENTRY";
export const UPDATE_TASK_ENTRIES_TOTAL_TIME = "UPDATE_TASK_ENTRIES_TOTAL_TIME";
export const UPDATE_TARGET_TRANSACTION = "UPDATE_TARGET_TRANSACTION";
export const SET_DAILY_TASKS_PAGINATION = "SET_DAILY_TASKS_PAGINATION";
export const RESET_DAILY_TASKS_PAGINATION = "RESET_DAILY_TASKS_PAGINATION";

export const RESET_TASK = "RESET_TASK";

export const PENDING = "Pending Approval";

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
};

export const fetchDailyTasks = () => {
  return (dispatch, getState) => {
    const userId = Cache.getItem("userId");
    client()
      .get("/daily-task/my-dailyTask", {
        params: {
          user_id: userId,
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          let tasks = result.data;
          if (!tasks.length) {
            tasks = null;
          } else {
            console.log(getState().dailyTasks);
            let numItems = tasks.length;
            let min = getState().dailyTasks.min;
            let max =
              numItems < MAX_ITEMS_IN_PAGE
                ? numItems
                : getState().dailyTasks.max;

            const totalPages = Math.ceil(numItems / MAX_ITEMS_IN_PAGE);

            dispatch({
              type: SET_DAILY_TASKS_PAGINATION,
              numItems,
              min,
              max,
              totalPages,
            });
          }
          dispatch({ type: FETCH_DAILY_TASKS, tasks });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const fetchTeamDailyTaskEntryDetailsById = (
  user_id,
  request_for_id,
  project_id,
  date,
  role_id
) => {
  return (dispatch) => {
    client()
      .get("daily-task/team-Task", {
        params: {
          user_id,
          request_for_id,
          project_id,
          date,
          role_id,
        },
      })
      .then((json) => {
        const result = json.data;

        if (date === "Invalid date") {
          dispatch(toggleShowAlert(true, ERROR_ALERT, "Date is required"));
        } else {
          if (result) {
            let teamDailyTask = result.data;

            dispatch({ type: FETCH_TEAM_DAILY_TASK_ENTRY, teamDailyTask });
          }
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};
export const fetchDailyTaskEntryById = (entry_id, user_id) => {
  return (dispatch) => {
    client()
      .get("/task-entries/get/dailyTaskId", {
        params: {
          id: entry_id,
          user_id,
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          let taskEntry = result.data;
          dispatch({ type: FETCH_DAILY_TASK_ENTRY, taskEntry });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const createDailyTask = () => {
  return (dispatch) => {
    const userId = Cache.getItem("userId");
    let date = new Date();
    let year = date.getFullYear();

    let month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : "0" + month;

    let day = date.getDate().toString();
    day = day.length > 1 ? day : "0" + day;

    const currDate = year + "/" + month + "/" + day;
    return client()
      .post("/daily-task/create", {
        request_for_id: userId,
        date: currDate,
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          return result.data;
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const createDailyTaskAssignment = (daily_task_id) => {
  return (dispatch) => {
    client()
      .post("/task-entries/create", {
        daily_task_id,
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          const TaskEntry = result.data;
          // const userId = Cache.getItem("userId");

          dispatch(fetchDailyTask(daily_task_id));
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};
export const deleteDailyTaskAssignment = (id, daily_task_id, user_id) => {
  return (dispatch) => {
    client()
      .post("/task-entries/delete", {
        id,
        daily_task_id: parseInt(daily_task_id),
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          const TaskEntry = result.data;

          dispatch(fetchDailyTask(parseInt(daily_task_id), user_id));
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const updateDailyTaskActivity = (
  entry_id,
  action,
  reason,
  remarks,
  daily_task_id,
  user_id
) => {
  return (dispatch) => {
    client()
      .post("/task-entries/update/taskActivity", {
        id: entry_id,
        action,
        reason,
        remarks,
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          const updatedTaskEntry = result.data;
          dispatch({ type: UPDATE_TASK_ENTRY, updatedTaskEntry });
          dispatch(fetchDailyTask(daily_task_id, user_id));
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};
export const updateDailyTaskRemark = (
  entry_id,
  remarks,
  daily_task_id,
  user_id
) => {
  return (dispatch) => {
    client()
      .post("/task-entries/remarks", {
        id: entry_id,
        remarks,
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          const updatedTaskEntry = result.data;
          dispatch({ type: UPDATE_TASK_ENTRY, updatedTaskEntry });
          dispatch(fetchDailyTask(daily_task_id, user_id));
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};
export const updateDailyTask = (
  id,
  project_id,
  task_id,
  daily_task_id,
  remarks
) => {
  return (dispatch) => {
    client()
      .post("/task-entries/update", {
        id,
        project_id,
        task_id,
        daily_task_id,
        remarks,
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          const updatedTaskEntry = result.data;
          const userId = Cache.getItem("userId");

          dispatch({ type: UPDATE_TASK_ENTRY, updatedTaskEntry });
          if (daily_task_id) dispatch(fetchDailyTask(daily_task_id, userId));
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const fetchDailyTask = (dailyTaskId, user_id) => {
  return (dispatch, getState) => {
    client()
      .get("/task-entries/list", {
        params: {
          daily_task_id: dailyTaskId,
          user_id,
        },
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          let task = result.data.entry_data;
          let totalActualTime = result.data.total_actual_time;
          let taskDate = result.task_date;
          if (task.length === 0) {
            task = [];
          }
          const rowNum = getState().dailyTasks.numRows;

          const newTask = task.map((taskEntry) => {
            return {
              remarks: taskEntry.remarks ?? "",
              reason: taskEntry.reason ?? "",
              action: taskEntry.action ?? "Pending",
              for_approval: taskEntry.for_approval,
              project_id: taskEntry.project_details.id ?? "",
              task_id: taskEntry.task_details.id ?? "",
              actual_time: taskEntry.actual_time ?? "",
              end_time: taskEntry.end_time ?? "",
              start_time: taskEntry.start_time ?? "",
              actual_transaction: taskEntry.actual_transaction ?? "",
              expected_transaction:
                taskEntry.task_assign_details.expected_transaction ?? "",
              sla: taskEntry.task_assign_details.task_sla ?? "",
              project_name: taskEntry.project_details.project_name ?? "",
              task_name: taskEntry.task_details.name ?? "",
              entry_id: taskEntry.id ?? parseInt(rowNum) + 1,
            };
          });
          dispatch({ type: FETCH_DAILY_TASK, task: newTask });
          dispatch({ type: UPDATE_TASK_ENTRIES, taskEntries: newTask });
          dispatch({
            type: UPDATE_TASK_ENTRIES_TOTAL_TIME,
            totalActualTime: totalActualTime,
          });
          dispatch({ type: SET_TASK_DATE, taskDate: taskDate });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const fetchOptions = () => {
  const userId = Cache.getItem("userId");

  return (dispatch) => {
    // const userId = Cache.getItem("userId");
    return client()
      .post("/task-assignment/get-task-option", {
        user_id: userId,
      })
      .then((json) => {
        const projectTask = json.data.data;

        if (projectTask) {
          let projectOptions = [];
          let taskOptions = [];
          projectTask.map((project) => {
            projectOptions.push({
              value: project.id,
              label: project.project_name,
            });

            taskOptions[`${project.id}`] = [];

            project.task_assignment.map((task) => {
              taskOptions[`${project.id}`].push({
                value: task.task_info.id,
                label: task.task_info.name,
              });
            });
          });
          dispatch({
            type: ASSIGN_PROJECT_TASK_OPTION,
            projectOptions,
            taskOptions,
          });
          dispatch({ type: FETCH_PROJECT_TASK_OPTION, projectTask });
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};

export const handleDailyTaskChange = (
  e,
  entry_id,
  new_entry_id,
  definedValue = null
) => {
  return (dispatch) => {
    let id = "";
    let value = "";
    if (definedValue === null) {
      id = e.target.id;
      value = e.target.value;
    } else {
      id = definedValue.id;
      value = definedValue.value;
    }

    dispatch({
      type: ADD_DAILY_TASK_ENTRY,
      id,
      value,
      entry_id,
      new_entry_id,
    });
  };
};

export const addTaskRow = () => {
  return (dispatch, getState) => {
    const dailyTasksEntries = getState().dailyTasks.taskEntries;
    const rowNum = getState().dailyTasks.numRows;
    if (dailyTasksEntries.length > 0) {
      dailyTasksEntries.forEach((taskEntries) => {
        let entry = {
          remarks: "",
          reason: "",
          action: "",
          project_id: "",
          task_id: "",

          entry_id: parseInt(rowNum) + 1,
        };
        dispatch({ type: ADD_TASK_ENTRY_DATE, entry });
      });
    }

    dispatch({ type: ADD_TASK_ROW_NUM });
  };
};

export const deleteTaskRow = (entryId) => {
  return (dispatch, getState) => {
    let lastRowID = 0;
    const dailyTaskEntries = getState().dailyTasks.taskEntries;

    const newDailyTaskEntries = dailyTaskEntries
      .filter((data) => {
        if (data.entry_id !== entryId) {
          if (data.entry_id > lastRowID) {
            lastRowID = data.entry_id;
          }
          return data;
        }
        return null;
      })
      .map((dailyTaskEntries) => {
        return dailyTaskEntries;
      });

    dispatch({
      type: SET_TASK_ROW_NUM,
      taskEntries: newDailyTaskEntries,
    });

    dispatch({ type: SET_TASK_ROW_NUM, rowNum: lastRowID });
    dispatch({ type: DELETE_TASK_ENTRY, entryId });
  };
};

export const resetDailyTasks = () => {
  return (dispatch) => {
    dispatch({ type: RESET_TASK });
  };
};

export const updateTargetTransaction = (id, userId, target) => {
  console.log(id, userId, target);
  return (dispatch) => {
    client()
      .post("/project-tasks/add-target", {
        project_task_id: id,
        target,
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          const updatedTargetTransaction = result.data;
          if (updatedTargetTransaction) {
            // dispatch(fetchTasks({ active: 1 }));
            dispatch(fetchProjectTasks());
          }
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};
export const deleteTargetTransaction = (id, userId, target) => {
  console.log(id, userId, target);
  return (dispatch) => {
    client()
      .post("/project-tasks/add-target", {
        project_task_id: id,
        target,
      })
      .then((json) => {
        const result = json.data;
        if (result) {
          const updatedTargetTransaction = result.data;
          if (updatedTargetTransaction) {
            dispatch(fetchTasks({ active: 1 }));
            dispatch(fetchProjectTasks());
          }
        }
      })
      .catch((error) => {
        dispatch(displayError(error));
      });
  };
};
